var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35607",
    "data-name": "Group 35607",
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    transform: "translate(1)",
    fill: "#fff",
    stroke: "#417ee4",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_36929",
    "data-name": "Group 36929",
    transform: "translate(-16.76 -26.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64119",
    "data-name": "Path 64119",
    d: "M48.161,38.811H34.351a.253.253,0,0,0-.253.252l-.016,3.806-.334-.6-.359-.647h0l-.514-.926h0l-.591-1.064a1.011,1.011,0,0,0-1.374-.393l-1.629.9a1.01,1.01,0,0,0-.393,1.374l.428.77v0l4.735,8.53-.005,6.528a.253.253,0,0,0,.253.253h7.226a2.391,2.391,0,0,0,1.9-.938l.007-.005,4.459-4.616s.008-.011.012-.016a1.669,1.669,0,0,0,.513-1.2V39.064A.253.253,0,0,0,48.161,38.811Zm-9.54,16.237-.736-.536a1.076,1.076,0,0,1,.67-.373Zm-.1-1.411a1.564,1.564,0,0,0-1.043.578l-1.5-1.089.4.133a.248.248,0,0,0,.079.013.253.253,0,0,0,.253-.246l.011-.412.449.17a.251.251,0,0,0,.09.017.256.256,0,0,0,.128-.035.253.253,0,0,0,.122-.182l.069-.48.377.146a.257.257,0,0,0,.091.017.249.249,0,0,0,.121-.031.252.252,0,0,0,.126-.171l.079-.387Zm-7.368-9.086.587-.326,4.49,8.088-.009.359-.685-.226Zm-1.109-2,2.513-1.395.27.486-2.512,1.395Zm6.616,9.494L32.18,43.98l.454-.252L37.116,51.8l-.057.4Zm-5.753-7.939-.348-.627,2.512-1.395.348.628Zm6.958,7.561-.309-.119-4.478-8.069.587-.326,4.341,7.821ZM29.285,40.885a.5.5,0,0,1,.24-.3l1.63-.9a.505.505,0,0,1,.687.2l.428.77v0l.039.071L29.8,42.111l-.468-.843A.5.5,0,0,1,29.285,40.885ZM41.524,57.09H34.551l0-5.366.58,1.045h0l.314.565a.251.251,0,0,0,.072.081l1.863,1.357.016.012,1.363.992a.254.254,0,0,0,.108.045.251.251,0,0,0,.079.013h.006l.844-.019a.253.253,0,0,0,.186-.087l.291-.336.339.4a.252.252,0,0,0,.193.089.212.212,0,0,0,.044,0,.253.253,0,0,0,.193-.16l.264-.708.247.627a.253.253,0,0,0,.235.16h.847a.253.253,0,1,0,0-.506h-.675l-.427-1.08c-.039-.1-.152-.183-.238-.16a.253.253,0,0,0-.235.165l-.343.922-.252-.3a.254.254,0,0,0-.191-.089.309.309,0,0,0-.193.088l-.41.475-.528.012-.1-1.455h0l-.167-2.314a.249.249,0,0,0-.031-.1l-.35-.631,0,0-3.909-7.042.019-4.456H47.908V50.823a1.16,1.16,0,0,1-.652,1.04,5.819,5.819,0,0,1-3.549.306.248.248,0,0,0-.206.056.253.253,0,0,0-.09.193V55.2A1.89,1.89,0,0,1,41.524,57.09ZM43.918,55.2V52.714a6.983,6.983,0,0,0,2.7-.087l-2.709,2.8C43.914,55.355,43.918,55.279,43.918,55.2Z",
    transform: "translate(0 0)",
    fill: "#417ee4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64120",
    "data-name": "Path 64120",
    d: "M242.986,131.858h5.624a.206.206,0,1,0,0-.412h-5.624a.206.206,0,0,0,0,.412Z",
    transform: "translate(-203.731 -88.608)",
    fill: "#417ee4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64121",
    "data-name": "Path 64121",
    d: "M242.986,182.966h5.624a.206.206,0,1,0,0-.412h-5.624a.206.206,0,0,0,0,.412Z",
    transform: "translate(-203.731 -137.495)",
    fill: "#417ee4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64122",
    "data-name": "Path 64122",
    d: "M248.817,233.862a.206.206,0,0,0-.206-.206h-5.624a.206.206,0,1,0,0,.412h5.624A.206.206,0,0,0,248.817,233.862Z",
    transform: "translate(-203.731 -186.376)",
    fill: "#417ee4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64123",
    "data-name": "Path 64123",
    d: "M256.36,284.751h-3.214a.206.206,0,0,0,0,.413h3.214a.206.206,0,1,0,0-.413Z",
    transform: "translate(-213.961 -235.25)",
    fill: "#417ee4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64124",
    "data-name": "Path 64124",
    d: "M311.147,77.039h.515a.206.206,0,1,0,0-.412h-.515a.206.206,0,1,0,0,.412Z",
    transform: "translate(-269.839 -36.483)",
    fill: "#417ee4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64125",
    "data-name": "Path 64125",
    d: "M354.985,77.039h.515a.206.206,0,1,0,0-.412h-.515a.206.206,0,1,0,0,.412Z",
    transform: "translate(-311.76 -36.483)",
    fill: "#417ee4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64126",
    "data-name": "Path 64126",
    d: "M267.316,77.039h.515a.206.206,0,1,0,0-.412h-.515a.206.206,0,0,0,0,.412Z",
    transform: "translate(-227.925 -36.483)",
    fill: "#417ee4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskIcon);
export default __webpack_public_path__ + "static/media/task_icon.8a35b41aef0d806edfb4d8e6cb6634c4.svg";
export { ForwardRef as ReactComponent };